import { FUTURE_NIGHTS_PAGE_SIZE } from './nightPagination';

export const nightCardStatus = ({
  index = 0,
  page = 1,
  pageSize = FUTURE_NIGHTS_PAGE_SIZE,
  scope = 'future',
} = {}) => {
  if (scope === 'past') {
    return {
      archived: true,
      labelKey: 'nights.pastGathering',
    };
  }

  const globalIndex = (Math.max(Number(page) || 1, 1) - 1) * pageSize + index;

  return {
    archived: false,
    labelKey: globalIndex === 0 ? 'nights.nextGathering' : 'nights.upcomingGathering',
  };
};
